import React from "react";
import { icons } from "../../assets/index";
import { Strings } from "../../constant/Strings";
import { useNavigate } from "react-router-dom";
import "./Button.scss"
const BackButton = (props: any) => {
  const { navigateTo } = props;
  const { back } = Strings;
  const navigate = useNavigate();
  return (
    <button
      type="button" 
      className="d-flex flex-row justify-content-between back-button"
      onClick={() => navigate(navigateTo)}
      title="Click here to move back" 
    >
      <img src={icons.backIcon} className="backIcon" alt="back button" />
      <p className="back-text">{back}</p>
    </button>
  );
};

export default BackButton;
